import get from 'lodash/get';
import { QUERY_ERROR } from '@atlassian/jira-issue-create-common-types/src/common/constants/graphql-field-types.tsx';
import type { FieldError } from '../../types/create-config-query.tsx';
import type { GqlUnsupportedFields } from '../../types/context-fields.tsx';
import type { TransformedQueryData } from '../../types/index.tsx';

export const getGqlUnsupportedFields = (
	errors: FieldError[],
): { unsupportedFields: GqlUnsupportedFields; isRequiredFieldTypeSupported: boolean } => {
	const unsupportedFields: GqlUnsupportedFields = {};
	let isRequiredFieldTypeSupported = true;
	errors.forEach(({ identifier, extensions }: FieldError) => {
		const extension = extensions?.[0];
		const gqlType = extension?.__typename;

		if (gqlType === 'JiraIssueFieldUnsupportedErrorExtension') {
			if (!extension) return;
			const { fieldName, fieldType, isRequiredField } = extension;
			unsupportedFields[identifier] = {
				gqlType,
				fieldId: identifier,
				fieldName,
				fieldType,
				isRequired: isRequiredField,
			};
			if (isRequiredField) {
				isRequiredFieldTypeSupported = false;
			}
		}
	});
	return {
		unsupportedFields,
		isRequiredFieldTypeSupported,
	};
};

export const getQueryErrorMessage = (data: TransformedQueryData): string => {
	const gqlIssueCreateFieldsType = get(data, 'jiraIssueCreateFields.__typename');
	const queryErrorMessage = get(data, 'jiraIssueCreateFields.message', '');
	if (gqlIssueCreateFieldsType === QUERY_ERROR && Boolean(queryErrorMessage)) {
		return queryErrorMessage;
	}

	const gqlIssueCreateLayoutType = data.jiraIssueCreateLayout.__typename;
	const error = data.jiraIssueCreateFields.errors?.[0]?.extensions?.[0];

	const issueCreateFieldsQueryErrorMessage =
		error && error.__typename === 'JiraIssueFieldValueValidationErrorExtension'
			? error.message
			: '';

	if (gqlIssueCreateLayoutType === QUERY_ERROR && Boolean(issueCreateFieldsQueryErrorMessage)) {
		return issueCreateFieldsQueryErrorMessage;
	}
	return '';
};
